import { Context, Controller } from '@hotwired/stimulus';

export default class DismissibleController extends Controller {
  static targets = [];

  constructor(context: Context) {
    super(context);
  }

  public onDismiss(): void {
    this.element.remove();
  }
}
